import * as model from './model.js';
import { MODAL_CLOSE_SEC } from './config.js';
import recipeView from './views/recipeView.js';
import searchView from './views/searchView.js';
import resultsView from './views/resultsView.js';
import paginationView from './views/paginationView.js';
import bookMarksView from './views/bookMarksView.js';
import addRecipeView from './views/addRecipeView.js';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { async } from 'regenerator-runtime';

// if (module.hot) {
//   module.hot.accept();
// }

const recipeContainer = document.querySelector('.recipe');

//////////////////////////////////////////////////////////////////

const controlRecipe = async function () {
  try {
    const id = window.location.hash.slice(1);
    // console.log(id);
    if (!id) return;
    recipeView.renderSpinner();

    // 0. Update results view to mark selected search result
    resultsView.update(model.getSearchResultsPage());

    // 1. Updating bookmark view
    bookMarksView.update(model.state.bookmarks);
    // 2. Loading recipe
    await model.loadRecipe(id);

    // 3. Rendering recipe
    recipeView.render(model.state.recipe);
  } catch (err) {
    recipeView.renderError();
    console.error(err);
  }
};

const controllSearchResult = async function () {
  try {
    resultsView.renderSpinner();

    // 1. Get search query
    const query = searchView.getQuery();
    if (!query) return;

    // 2. Get search
    await model.loadSearchResults(query);

    // 3. render search
    resultsView.render(model.getSearchResultsPage());

    // 4. Render pagination buttons
    paginationView.render(model.state.search);
  } catch (err) {
    console.log(err);
  }
};

const controllPagination = function (goToPage) {
  // 1. render NEW search
  resultsView.render(model.getSearchResultsPage(goToPage));

  // 2. Render NEW pagination buttons
  paginationView.render(model.state.search);
};

const controlServing = function (newServings) {
  // Updating serving store in the state
  model.updateServings(newServings);

  // Updating the recipeView
  // recipeView.render(model.state.recipe);
  recipeView.update(model.state.recipe);
};

const controlBookMark = function () {
  // 1. Add/remove bookmark
  if (!model.state.recipe.bookmarked) model.addBookMark(model.state.recipe);
  else model.removeBookMark(model.state.recipe.id);

  // 2. Update recipe view
  recipeView.update(model.state.recipe);

  // 3. Render Bookmark
  bookMarksView.render(model.state.bookmarks);
};

const controlBookmarks = function () {
  bookMarksView.render(model.state.bookmarks);
};

const controlAddRecipe = async function (newRecipe) {
  try {
    //* Show loading user
    addRecipeView.renderSpinner();

    //! Upload the recipe data
    await model.uploadRecipe(newRecipe);
    console.log(model.state.recipe);

    //! Render recipe
    recipeView.render(model.state.recipe);

    //*Success Message
    addRecipeView.renderMessage();

    //? Render bookmarks view
    bookMarksView.render(model.state.bookmarks);

    //? Change id in the URL
    window.history.pushState(null, '', `#${model.state.recipe.id}`);
    //! Close form window
    setTimeout(function () {
      addRecipeView.toggleWindow();
    }, MODAL_CLOSE_SEC * 1000);
  } catch (err) {
    console.error('😢', err);
    addRecipeView.renderError(err.message);
  }
  location.reload();
};

const newFeature = function () {
  console.log('Welcome to the application');
};

const init = function () {
  bookMarksView.addHandlerRender(controlBookmarks);
  recipeView.addHandlerRender(controlRecipe);
  recipeView.addHandleUpdateServings(controlServing);
  recipeView.addHandlerAddBookMark(controlBookMark);
  searchView.addHandlerSearch(controllSearchResult);
  paginationView.addhandleClick(controllPagination);
  addRecipeView.addHandlerUpload(controlAddRecipe);
  newFeature();
};

init();
